export default __webpack_public_path__ + "assets/4992b6c71598f7f9412d4e47f4d4f32a.svg";